export default "__VITE_ASSET__69f483f8__"